<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.95 10.31 8.03 2.29a.483.483 0 0 0-.19-.21.574.574 0 0 0-.58 0 .43.43 0 0 0-.19.21L4.4 7.764 3.29 5.496a.574.574 0 0 0-.19-.22.538.538 0 0 0-.28-.08c-.1 0-.19.03-.28.08-.09.05-.15.13-.19.22L.06 10.211c-.04.08-.06.17-.06.27s.03.18.08.26c.05.08.11.14.19.19.08.039.17.069.26.069h10.95a.543.543 0 0 0 .44-.22.4.4 0 0 0 .08-.23c0-.08 0-.16-.04-.24h-.01z"
        />
    </svg>
</template>
